import { useNavigate } from "react-router-dom";
import { FaChevronRight, FaChevronLeft } from "react-icons/fa";
import React, { Suspense, lazy, useEffect, useRef, useState } from "react";
import RecomendedItem from "../Components/RecomendedItem";
import RecomItems from "../Components/RecomItems";
import SubCategoryItems from "../Components/SubCategoryItems";
import { _get } from "../services/apiClient";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
function Home({ cart }) {
  const [categories, setCategories] = useState([]);
  const navigate = useNavigate();
  const [banners, setBanners] = useState([]);
  const [subCategories, setsubCategories] = useState([]);
  const [hovered, setHovered] = useState(false);
  const toggleHover = () => setHovered(!hovered);
  const [showAll, setShowAll] = useState(false);

  const displayedCategories = showAll ? categories : categories.slice(0, 10);
  useEffect(() => {
    fetchCategoriesData();
    //fetchSubCategoriesData();
  }, []);
  const fetchBannerData = async () => {
    try {
      const response = await _get(`/banners`);
      const currentTime = new Date();

      const activeBanners = response.data.filter((b) => {
        const startTime = new Date(b.startDate);
        const endTime = new Date(b.endDate);

        return startTime <= currentTime && endTime > currentTime;
      });

      setBanners(activeBanners.length > 0 ? activeBanners : []);
    } catch (error) {
      console.error("Error fetching banner:", error);
    }
  };

  useEffect(() => {
    fetchBannerData();
    const interval = setInterval(fetchBannerData, 60000);
    return () => clearInterval(interval);
  }, []);
  const fetchCategoriesData = async () => {
    try {
      const response = await _get(`/categories`);
      setCategories(response.data);
    } catch (error) {
      console.error("Error fetching data:", error);
      // Handle errors
    }
  };

  const categoryColors = [
    "#FFF3FF",
    "#FDF1D3",
    "#FFFCEB",
    "#F2FCE4",
    "#FEEFEA",
    "#F0F8FF",
    "#FDE2FF",
    "#FAF3DD",
    "#FFE5EC",
    "#E0F7FA",
    "#FFF0D9",
    "#F9F9F9",
    "#FFF5E1",
    "#E8F6EF",
    "#FFE9EC",
    "#FFFBEA",
    "#F6F6F6",
    "#F3FFE3",
    "#FFF4F4",
    "#F2F2FD",
    "#FFF7EB",
    "#ECFDF5",
    "#FFFAF0",
    "#FFF7F1",
    "#FDF4F5",
  ];
  const settings = {
    dots: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: true,
    customPaging: () => (
      <div
        style={{
          width: "6px",
          height: "6px",
          backgroundColor: "black",
          borderRadius: "50%",
          margin: "0 5px",
          transition: "background-color 0.3s ease",
        }}
      ></div>
    ),
    appendDots: (dots) => (
      <div
        style={{
          position: "relative",
          bottom: "-40px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",

          paddingTop: "20px",
        }}
      >
        <ul
          style={{
            margin: "0",
            padding: "0",
            listStyle: "none",
            display: "flex",
          }}
        >
          {dots}
        </ul>
      </div>
    ),
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  return (
    <div className="container">
      <SubCategoryItems recommendedItemLists={subCategories} cart={cart} />
      {/* <RecomItems  recommendedItemLists={recommendedItem}/> */}
      <div
        style={{
          backgroundColor: "#f8f9fa",
          padding: "10px",
          borderRadius: "10px",
        }}
      >
        {banners.length > 0 ? (
          <>
            <h5
              style={{
                marginBottom: "10px",
                fontWeight: "600",
                textAlign: "left",
              }}
            >
              Featured Items
            </h5>
            <Slider {...settings}>
              {banners.length > 0
                ? [...Array(Math.max(3, banners.length))].map((_, index) => {
                    const banner = banners[index % banners.length];
                    return (
                      <div key={index} style={{ padding: "10px" }}>
                        <div
                          style={{
                            backgroundColor: "white",
                            border: "1px solid #ddd",
                            borderRadius: "10px",
                            boxShadow: "0px 4px 8px rgba(0,0,0,0.2)",
                            overflow: "hidden",
                            textAlign: "center",
                            padding: "10px",
                            color: "blue",
                            height: "280px",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "space-between",
                          }}
                        >
                          <img
                            src={`${process.env.REACT_APP_IMAGE_BASE_URL}${
                              banner.imagePath.startsWith("/")
                                ? banner.imagePath
                                : `/${banner.imagePath}`
                            }`}
                            alt={`Banner ${index + 1}`}
                            style={{
                              width: "100%",
                              height: "220px",
                              objectFit: "cover",
                              borderRadius: "8px",
                              backgroundColor: "#fff",
                            }}
                            className="img-fluid"
                          />

                          {banner.description && (
                            <h6
                              style={{
                                marginTop: "10px",
                                fontWeight: "600",
                                color: "black",
                              }}
                            >
                              {banner.description}
                            </h6>
                          )}
                        </div>
                      </div>
                    );
                  })
                : null}
            </Slider>
          </>
        ) : null}
      </div>

      <div className="container">
        <div className="pt-4 pb-2 title d-flex align-items-center">
          <h5 className="m-0">Browse By Category</h5>
          <a
            className="font-weight-bold ml-auto"
            style={{ display: "none" }}
            href="/products"
          >
            View all <i className="feather-chevrons-right"></i>
          </a>
        </div>

        <div>
          <div className="row">
            {displayedCategories.map((item, index) => (
              <div
                key={item._id}
                className="col-lg-2 col-md-3 col-sm-6 col-6 mb-3"
              >
                <div
                  className="cat-item px-1 py-2 text-center shadow-sm img-hover-scale"
                  style={{
                    backgroundColor:
                      categoryColors[index % categoryColors.length],
                    borderRadius: "10px",
                    fontSize: "14px",
                  }}
                >
                  <a
                    onClick={() => navigate(`/products/${item._id}`)}
                    style={{
                      display: "block",
                      textDecoration: "none",
                      borderRadius: "8px",
                    }}
                    className="category-link"
                  >
                    <img
                      src={`${process.env.REACT_APP_IMAGE_BASE_URL}${item.images?.[0]}`}
                      alt={item.name}
                      className="img-fluid mb-2"
                      style={{
                        borderRadius: "5px",
                        objectFit: "cover",
                      }}
                    />
                  </a>
                  <h6
                    className="category-name"
                    style={{
                      marginTop: "5px",
                      fontSize: "12px",
                      fontWeight: "bold",
                    }}
                  >
                    {item.name}
                  </h6>
                </div>
              </div>
            ))}
            {!showAll && categories.length > 10 && (
              <div className="col-lg-2 col-md-3 col-sm-6 col-6 mb-3 d-flex align-items-center justify-content-center">
                <div
                  className="view-more-icon d-flex align-items-center justify-content-center shadow-sm img-hover-scale"
                  onClick={() => setShowAll(true)}
                  style={{
                    cursor: "pointer",
                    padding: "10px",
                    borderRadius: "10px",
                    backgroundColor: "#f0f0f0",
                    width: "70px",
                    height: "70px",
                    fontSize: "16px",
                    fontWeight: "bold",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "black",
                  }}
                >
                  <FaChevronRight size={25} />
                  <span style={{ fontSize: "12px", marginTop: "2px" }}>
                    More
                  </span>
                </div>
              </div>
            )}

            {showAll && (
              <div className="col-lg-2 col-md-3 col-sm-6 col-6 mb-3 d-flex align-items-center justify-content-center">
                <div
                  className="view-less-icon d-flex align-items-center justify-content-center shadow-sm img-hover-scale"
                  onClick={() => setShowAll(false)}
                  style={{
                    cursor: "pointer",
                    padding: "10px",
                    borderRadius: "10px",
                    backgroundColor: "#f0f0f0",
                    width: "70px",
                    height: "70px",
                    fontSize: "16px",
                    fontWeight: "bold",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "black",
                  }}
                >
                  <FaChevronLeft size={25} />
                  <span style={{ fontSize: "12px", marginTop: "2px" }}>
                    Less
                  </span>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Home;
